import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relative flex items-center" }
const _hoisted_2 = { class: "flex items-center h-4" }
const _hoisted_3 = ["id", "checked", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "ml-3 text-sm"
}
const _hoisted_5 = ["for"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    isChecked: {
        type: Boolean,
        default: false,
    },
    defaultSlot: {
        type: Boolean,
        default: true,
    },
    modelValue: {
        default: null,
        required: true,
    },
    id: {
        type: String,
    },
    label: {
        type: String,
    },
    rounded: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    textColor: {
        type: String,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: __props.id,
        type: "checkbox",
        class: "cursor-pointer h-5 w-5 text-gray-300 border-gray-300 rounded focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-600",
        checked: __props.isChecked,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked))),
        disabled: __props.disabled
      }, null, 40, _hoisted_3)
    ]),
    (__props.defaultSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", {
            for: __props.id,
            class: "cursor-pointer text-primary-900 text-sm"
          }, _toDisplayString(__props.label), 9, _hoisted_5)
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ]))
}
}

})